import {useContext} from "@mytour/platform";
import {invoiceDocumentKeys} from "@mytour/shared";
import {useQuery} from "@tanstack/react-query";
import {invoiceDocumentApiService} from "./invoiceDocumentApi.service";

export function useInvoiceDocumentsByCustomer(customerId: string, enabled = true) {
  const {context} = useContext();
  const canRead =
    context?.role === "manager" ||
    (context?.role === "worker" && context.permissions.canCreateInvoice);
  const {data, isLoading} = useQuery({
    queryKey: [
      ...invoiceDocumentKeys.customer(customerId),
      context?.companyId,
      context?.role,
      canRead,
    ],
    queryFn: () => invoiceDocumentApiService.listCustomerDocuments(customerId),
    enabled: enabled && !!customerId && !!canRead,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
  return {invoiceDocuments: canRead ? data : undefined, isInvoiceDocumentsLoading: isLoading};
}
